import { Box, Typography, Tooltip, useTheme } from "@mui/material";
import { badge, badges } from "../../styles/badgeStyles";
import { tokens } from "../../theme";
import { styles } from "./styles";

const pillStyles = (colors) => ({
  passed: badge(colors.okBg, colors.okFg),
  failed: badge(colors.errBg, colors.errFg),
  skipped: badges(colors).neutral,
});

const ResultBox = ({ compliedResults, sx }) => {
  const theme = useTheme();
  const pills = pillStyles(tokens(theme.paletteId));
  const hasResults = ["passed", "failed", "skipped"].some(
    (key) => compliedResults?.[key] != null
  );

  if (!hasResults) {
    return <Box sx={sx || styles.resultStack}>—</Box>;
  }

  const tooltipTitle = (
    <Box>
      <Typography variant="body2">
        Passed: {compliedResults?.passed ?? "-"}
      </Typography>
      <Typography variant="body2">
        Failed: {compliedResults?.failed ?? "-"}
      </Typography>
      <Typography variant="body2">
        Skipped: {compliedResults?.skipped ?? "-"}
      </Typography>
    </Box>
  );

  return (
    <Tooltip title={tooltipTitle} arrow>
      <Box sx={sx || styles.resultStack}>
        <Box component="span" sx={pills.passed}>
          {compliedResults?.passed ?? 0} passed
        </Box>
        {(compliedResults?.failed ?? 0) > 0 && (
          <Box component="span" sx={pills.failed}>
            {compliedResults?.failed} failed
          </Box>
        )}
        {(compliedResults?.skipped ?? 0) > 0 && (
          <Box component="span" sx={pills.skipped}>
            {compliedResults?.skipped} skipped
          </Box>
        )}
      </Box>
    </Tooltip>
  );
};

export default ResultBox;
